import gql from 'graphql-tag';

export default id => {
  const getRoleGroupById = `getRoleGroupById(input: {id: "${id}"})`;
  return gql`
    query {
      ${getRoleGroupById} {
        roleGroupRoles {
          index
          roleId
        }
      }
    }
  `;
};
